import { DISABLE_LOADING, DisableLoading, ENABLE_LOADING, EnableLoading } from './types';

export const enableListLoading = (): EnableLoading => {
    return { type: ENABLE_LOADING };
};

export const disableListLoading = (): DisableLoading => {
    return { type: DISABLE_LOADING };
};
